import React, { FC, useContext } from 'react';
import { IsMobileContext } from 'App';
import RSuiteDateRangePicker from 'rsuite/DateRangePicker';
import { DateRange } from 'rsuite/DateRangePicker';
import { dateRanges } from './constants';
import 'rsuite/dist/rsuite.min.css';

const { afterToday } = RSuiteDateRangePicker;

interface DateRangePickerProps {
  label: string;
  startDate: Date | null;
  endDate: Date | null;
  onDateChange: (dateRange: DateRange | null) => void;
  onDateClear: () => void;
  className?: string;
  disableDatesAfterToday?: boolean;
}

const DateRangePicker: FC<React.PropsWithChildren<DateRangePickerProps>> = ({
  label,
  startDate,
  endDate,
  onDateChange,
  onDateClear,
  className,
  disableDatesAfterToday = false,
}) => {
  const isMobile = useContext(IsMobileContext);
  return (
    <div
      className={`bg-white font-montserrat flex items-center shadow-[2px_4px_4px_rgba(0,0,0,0.07)] rounded-[5px] max-[1279px]:basis-full max-[1279px]:min-w-[320px] ${className ||
        ''}`}
    >
      <div className="text-[#575757] mx-[10px] my-0 text-base pl-[5px] max-[460px]:text-sm max-[460px]:whitespace-nowrap">
        {label}
      </div>
      <RSuiteDateRangePicker
        {...(isMobile && { showOneCalendar: true })}
        size="lg"
        appearance="subtle"
        shouldDisableDate={disableDatesAfterToday ? afterToday!() : undefined}
        value={startDate && endDate ? [startDate, endDate] : null}
        onChange={dateRange => onDateChange(dateRange)}
        onClean={() => onDateClear()}
        ranges={dateRanges}
        data-testid="date-picker"
        className="flex-grow"
      />
    </div>
  );
};

export default DateRangePicker;
